
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      sid: "" as any,
      light: null as any,
      order: null as any,
      printLoading: null as any,
    };
  },
  async mounted() {
    this.sid = this.$route.query.sid;
    await this.getDetail();
  },
  methods: {
    handlePrint() {
      // 防止重复点击
      if (this.printLoading) {
        return;
      }
      this.printLoading = true;

      // 滚动至页面顶部，避免打印缺少标题
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });

      // 等待滚动生效后唤起打印
      setTimeout(() => {
        try {
          window.print();
        } catch (err) {
          console.error("打印调用异常：", err);
          this.$message?.error("当前浏览器不支持打印功能");
        }

        // 延时关闭loading，给打印弹窗弹出留出时间
        setTimeout(() => {
          this.printLoading = false;
        }, 800);
      }, 50);
    },
    async getDetail() {
      const req = {
        Data: this.sid,
      };
      const light: any = await HttpUtil.XCHttpPost(
        Urls.GetLightInspection,
        req,
        false,
        false
      );
      this.light = light;
      const order: any = await HttpUtil.XCHttpPost(
        Urls.GetOrderInspection,
        req,
        false,
        false
      );
      this.order = order;
    },
  },
});
